import { useSelector } from 'react-redux';

import { useQuery } from '../../../../../hooks/routing/use-query';
import Global from '../../../../../store/global-selectors';
import { ImportStatus } from '../../../data/types/import-status';
import { StepType } from '../../../data/types/step-type';
import { csvJobIdParam } from '../../constants';
import { useImportContext } from '../import-context';
import { ImportDrawer } from '../import-drawer/import-drawer';
import { StepDetectiveProvider } from '../step-detective/step-detective-context';

/**
 * @param {object} props
 * @param {Array<import('../../types/types').ImportStep>} props.steps
 * @param {React.ReactNode} props.header
 * @param {(stepId: string) => () => void} props.onCancel
 * @param {string} [props.startStepId]
 * @returns {JSX.Element}
 */
export const SingleImportDrawer = ({ steps, startStepId = StepType.CREATE_CONFIG, ...importDrawerProps }) => {
  const { importType } = useImportContext();
  const importJobId = useQuery().get(csvJobIdParam);
  const latestImport = useSelector((state) => Global.selectCsvImportType(state, importType));

  const isProcessing = latestImport.status === ImportStatus.ACTIVE || !!importJobId;

  const startStep = isProcessing
    ? steps.find((step) => step.id === StepType.IMPORT_IS_PROCESSING)
    : steps.find((step) => step.id === startStepId);

  return (
    <StepDetectiveProvider originalSteps={steps} startStep={startStep}>
      <ImportDrawer {...importDrawerProps} />
    </StepDetectiveProvider>
  );
};
